/**
 * Mobile column visibility for ag-grid entity tables.
 *
 * Per-entity overrides: set `tableParams.mobileCriticalFields` or export a config
 * from the entity's grid-view-config and spread it into tableParams.
 *
 * Per-column overrides: set `mobileCritical: true | false` on a ColDef.
 */
export const MOBILE_BREAKPOINT_PX = 768;

export const DEFAULT_MOBILE_CRITICAL_FIELDS = [
  'actions',
  'name',
  'title',
  'enabled',
  'status',
] as const;

export type MobileCriticalField = (typeof DEFAULT_MOBILE_CRITICAL_FIELDS)[number];

export interface AgGridMobileConfig {
  mobileCriticalFields?: string[];
}

export const DEFAULT_TABLE_MOBILE_CONFIG: AgGridMobileConfig = {
  mobileCriticalFields: [...DEFAULT_MOBILE_CRITICAL_FIELDS],
};

/** Column IDs that must never be hidden by saved state or mobile layout rules. */
export const PROTECTED_ALWAYS_VISIBLE_COL_IDS = ['id', 'actions'] as const;

export function getMobileCriticalFields(tableParams?: {
  mobileCriticalFields?: string[];
}): string[] {
  return tableParams?.mobileCriticalFields ?? [...DEFAULT_MOBILE_CRITICAL_FIELDS];
}
